import { render, staticRenderFns } from "./InvoicesList.vue?vue&type=template&id=0540fa23&scoped=true&"
import script from "./InvoicesList.vue?vue&type=script&lang=js&"
export * from "./InvoicesList.vue?vue&type=script&lang=js&"
import style0 from "./InvoicesList.vue?vue&type=style&index=0&id=0540fa23&lang=scss&scoped=true&"
import style1 from "./InvoicesList.vue?vue&type=style&index=1&lang=scss&"
import style2 from "./InvoicesList.vue?vue&type=style&index=2&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0540fa23",
  null
  
)

export default component.exports